module.exports = __webpack_public_path__ + "img/dots_rdb_1.a5720913.png";